


























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class PriceHubl extends Vue {
    @Prop({ required: true }) title!: string;

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
    };

    isOpen = false;
    isLoading = true;

    private initPriceHubl() {
        this.isOpen = true;
        setTimeout(() => {
            this.isLoading = false;
        }, 1500);
        this.$nextTick(function() {
            // @ts-ignore
            FisherWidget.init({
                apiKey: "12ba2db01f1347fba0910b10746350db",
                iframe: "#fisher-widget",
                activeColor: "beaf87",
                buttonColor: "beaf87",
                textColor: "252526",
                lang: "nl",
                gaTrackingId: "UA-141571083-1",
                scrollTopOffset: 0,
                consentGranted: true
            });
        });
    }

    @Watch("isOpen")
    handleOpen(isOpen: boolean) {
        if (isOpen) {
            //@ts-ignore
            document.documentElement.style.overflow = "hidden";
        } else {
            //@ts-ignore
            document.documentElement.style.overflow = "auto";
        }
    }
}
